// Numéro d'un signalement : "SIG-AAMMJJ-HHMMSS", en heure LOCALE (celle de la
// personne qui signale — c'est ce numéro qu'elle garde pour en reparler,
// il doit correspondre à ce qu'elle a vécu, pas à l'UTC du serveur).

function pad2(n: number): string {
  return n.toString().padStart(2, "0");
}

export function numeroSignalement(d: Date): string {
  const aa = pad2(d.getFullYear() % 100);
  const mm = pad2(d.getMonth() + 1);
  const jj = pad2(d.getDate());
  const hh = pad2(d.getHours());
  const min = pad2(d.getMinutes());
  const ss = pad2(d.getSeconds());
  return `SIG-${aa}${mm}${jj}-${hh}${min}${ss}`;
}
